let forceSliders = [];

document.addEventListener("DOMContentLoaded", function () {

  // ── Header background overlay ──────────────────────────────────────────
  const headerBg = document.createElement("div");
  headerBg.className = "header-background-overlay";

  const headerElement = document.querySelector(".arHeaderSectionAbsolute");
  if (headerElement) {
    headerElement.insertBefore(headerBg, headerElement.firstChild);

    let lastScrollY = window.scrollY;
    let ticking = false;

    window.addEventListener("scroll", function () {
      lastScrollY = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function () {
          headerBg.style.opacity = lastScrollY > 50 ? "1" : "0";
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── Force sliders ──────────────────────────────────────────────────────
  forceSliders = document.querySelectorAll('grid-slider[data-force-slider]');

  forceSliders.forEach(gridSlider => {
    if (!window.theme) return;
    const sliderEl = gridSlider.querySelector('[data-grid-slider]');
    const slides = sliderEl?.querySelectorAll('[data-grid-item]') || [];
    if (!sliderEl || slides.length < 2) return;

    const originalTouch = window.theme?.touch;
    try {
      window.theme.touch = false;
      gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
    } finally {
      window.theme.touch = originalTouch;
    }
  });

  // ── Collection description toggle ─────────────────────────────────────
  document.querySelectorAll(".nexgi-desc-toggle").forEach(button => {
    button.addEventListener("click", function () {
      const container = this.closest(".nexgi-collection-desc");
      const text = this.querySelector("span");
      if (!container || !text) return;
      container.classList.toggle("expanded");
      text.textContent = container.classList.contains("expanded") ? "Read Less" : "Read More";
    });
  });

});

// ── Resize handler ─────────────────────────────────────────────────────
window.addEventListener('resize', () => {
  forceSliders.forEach(slider => {
    slider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
  });
});

// auto play the hero video after dom load
window.addEventListener('DOMContentLoaded', function () {
  var isMobile = window.innerWidth < 600;
  var selector = isMobile
    ? '.arHero__bg-video--mobile'
    : '.arHero__bg-video--desktop';

  var video = document.querySelector(selector + '[data-autoplay]');
  if (!video) return;

  var src = video.getAttribute('data-src');
  if (src) {
    video.setAttribute('src', src);
    video.load();
    video.play().catch(function () {});
  }
});